// Packages and components
import React from 'react';
import { Box } from 'grommet';
import FormPreviousStyled from './SHDBackButton.styles';
// Helpers
import { useHistory } from 'react-router-dom';
import { Sizes } from '@theme/globals/sizing';

// Types
import { SHDBackButtonProps } from './SHDBackButton.d';

const SHDBackButton: React.FC<SHDBackButtonProps> = ({
  customBackUrl,
  onClick,
}) => {
  const baseSize = Sizes[36];
  const history = useHistory();

  const handleOnClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    customBackUrl ? history.push(customBackUrl) : history.goBack();
  };

  return (
    <Box
      align="start"
      aria-label="Go Back"
      height={baseSize}
      justify="start"
      onClick={handleOnClick}
      role="button"
      width={baseSize}
    >
      <FormPreviousStyled color="gray-800" size={baseSize} />
    </Box>
  );
};

export default SHDBackButton;
